import { useState } from 'react';

import { checkPassword } from '@lib/util/check-password';

// 密碼欄位的狀態（值 + 錯誤訊息）
export type PasswordFieldState = {
  value: string;
  error: string;
};

type UsePasswordFormReturn = {
  password1: PasswordFieldState;
  password2: PasswordFieldState;
  handlePassword1Change: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePassword2Change: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** 任一密碼欄位有錯誤或為空時為 true */
  hasValidationError: boolean;
};

// 比對兩次輸入的密碼是否一致
const getPasswordMatchError = (pwd1: string, pwd2: string): string => {
  return pwd1 !== pwd2 ? '您輸入的密碼不一致，請重新輸入' : '';
};

/**
 * 共用的密碼表單邏輯 hook，處理密碼驗證與比對。
 * 供帳號設定完成和重設密碼頁面共用。
 */
export const usePasswordForm = (): UsePasswordFormReturn => {
  const [password1, setPassword1] = useState<PasswordFieldState>({
    value: '',
    error: '',
  });
  const [password2, setPassword2] = useState<PasswordFieldState>({
    value: '',
    error: '',
  });

  // 處理密碼輸入：驗證格式，並在確認密碼已填寫時重新比對一致性
  const handlePassword1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword1({
      value,
      error: checkPassword(value),
    });

    if (password2.value) {
      setPassword2({
        value: password2.value,
        error: getPasswordMatchError(value, password2.value),
      });
    }
  };

  // 處理確認密碼輸入：比對是否與密碼一致
  const handlePassword2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword2({
      value,
      error: getPasswordMatchError(password1.value, value),
    });
  };

  const hasValidationError =
    password1.error !== '' ||
    password2.error !== '' ||
    password1.value === '' ||
    password2.value === '';

  return {
    password1,
    password2,
    handlePassword1Change,
    handlePassword2Change,
    hasValidationError,
  };
};
